export default __webpack_public_path__ + "static/media/refresh-circle.2cedf29c.svg";